module.exports = __webpack_public_path__ + "img/opt_avsb_logo_no_text.fe219430.svg";